import { StateCreator } from "zustand";

import { PlayerStoreProperties } from "../store";
import { StoreMiddlewares } from "../storeTypes";

export type TimeSliceState = {
  buffered: number | undefined;
  currentTime: number;
  durationInSeconds: number | undefined;
  dvrWindow: number | undefined;
  isSeeking: boolean;
  seekableEnd: number | undefined;
};

type TimeSliceActions = {
  setBuffered: (buffered: number | undefined) => void;
  setCurrentTime: (currentTime: number) => void;
  setDurationInSeconds: (duration: number) => void;
  setIsSeeking: (isSeeking: boolean) => void;
  setSeekableEnd: (seekableEnd: number | undefined) => void;
};

export type TimeSlice = TimeSliceState & TimeSliceActions;

export const TIME_SLICE_DEFAULTS: TimeSliceState = {
  buffered: undefined,
  currentTime: -1,
  durationInSeconds: undefined,
  dvrWindow: undefined,
  isSeeking: false,
  seekableEnd: undefined
};

export const timeSlice: StateCreator<
  PlayerStoreProperties,
  StoreMiddlewares,
  [],
  TimeSlice
> = set => ({
  ...TIME_SLICE_DEFAULTS,
  setBuffered: buffered => set({ buffered }, false, "setBuffered"),
  setCurrentTime: currentTime =>
    set({ currentTime: Math.round(currentTime) }, false, "setCurrentTime"),
  setDurationInSeconds: durationInSeconds =>
    set({ durationInSeconds }, false, "setDurationInSeconds"),
  setIsSeeking: isSeeking => set({ isSeeking }, false, "setIsSeeking"),
  setSeekableEnd: seekableEnd => set({ seekableEnd }, false, "setSeekableEnd")
});
